export const MOVEMENT_SERVICES_FIELDS = Object.freeze({
  orderId: "ID",
  from: "From",
  fromAreaBerth: "From Area / Berth",
  to: "To",
  toAreaBerth: "To Area / Berth",
  rts: "RTS",
  rta: "RTA",
  rtd: "RTD",
  ets: "ETS",
  ats: "ATS",
  etc: "ETC",
  status: "Status",
});
